import React, { Component, useState, useEffect } from "react";
import Select from "react-select";
import { ListButton, usePermissions } from "react-admin";
import { Papa, getLocalStorageKey } from "../common/common";

import {
  RUN_TIME_API_ENDPOINT,
  CommonHeaderOption,
  DigitalOrderSystem,
  EmptyPagination,
} from "../common/common";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

const SendMessageCreate = (props) => {
  const navigate = useNavigate();
  const permissions = usePermissions();
  console.log("permissions////////////", permissions);
  const [showLoader, setShowLoader] = useState(false);
  const [successMsg, setSuccessMsg] = useState(false);
  const [validationError, setValidationError] = useState(false);
  const [validationPurposeError, setValidationPurposeError] = useState(false);
  const [validateDescriptionError, setValidateDescriptionError] =
    useState(false);
  const [saveButtonDisabled, setSaveButtonDisabled] = useState(true);
  const [errorMsg, setErrorMsg] = useState(false);
  const [errorMsgText, setErrorMsgText] = useState(null);
  const [type, setType] = useState("Country");
  const [originalList, setOriginalList] = useState([]);
  const [saleOffNameSapCode, setSaleOffNameSapCode] = useState([]);
  const [parsedCSVdata, setParsedCSVdata] = useState([]);
  const [charPerMsg, setCharPerMsg] = useState(160);
  const [messageCount, setMessageCount] = useState(0);
  const [descCharLeft, setDescCharLeft] = useState(640);
  const [descMaxChar, setDescMaxChar] = useState(640);
  const [unregisteredRetailers, setUnregisteredRetailers] = useState([]);
  const [pasrsedSimilarDataLength, setPasrsedSimilarDataLength] = useState(0);
  const [pasrsedDifferentDataLength, setPasrsedDifferentDataLength] =
    useState(0);
  const [unregisteredRetailersToggle, setUnregisteredRetailersToggle] =
    useState(false);
  const [saleOffList, setSaleOffList] = useState([]);
  const [totalSMSCost, setTotalSMSCost] = useState(0);
  const [soSapCodeList, setSoSapCodeList] = useState([]);
  const [soList, setSoList] = useState([]);
  const [isSoListPresent, setIsSoListPresent] = useState(false);
  const [regionSapCodeList, setRegionSapCodeList] = useState([]);
  const [originalRegionList, setOriginalRegionList] = useState([]);
  const [regionList, setRegionList] = useState([]);
  const [isRegionListPresent, setIsRegionListPresent] = useState(false);
  const [customerGroupSapCodeList, setCustomerGroupSapCodeList] = useState([]);
  const [originalCustomerGroupList, setOriginalCustomerGroupList] = useState(
    []
  );
  const [customerGroupList, setCustomerGroupList] = useState([]);
  const [isCustomerGroupListPresent, setIscustomerGroupListPresent] =
    useState(false);
  const [showModal, setShowModal] = useState(false);
  const [smsPurpose, setSmsPurpose] = useState("");
  const [originalSOList, setOriginalSOList] = useState([]);
  const [smsDescription, setSmsDescription] = useState("");

  useEffect(() => {
    const options = CommonHeaderOption();
    const apiUrl = RUN_TIME_API_ENDPOINT;
    options.method = "GET";
    fetch(`${apiUrl}/so_business_list`, options)
      .then((res) => {
        return res.json();
      })
      .then((jsonD) => {
        console.log("jsonD ===>", jsonD);
        let obj = {};
        obj.sap_order_materials = jsonD.data;
        obj.loadingShow = false;
        // console.log('obj==>', obj);
        setOriginalList(
          obj.sap_order_materials.map((item) => ({
            id: item.id,
            value: item.label,
            label: item.label,
            sap: item.sap_code.trim(),
          }))
        );
        setSaleOffNameSapCode(
          obj.sap_order_materials.map((item) => ({
            id: item.id,
            value: item.label,
            label: item.label,
            sap: item.sap_code.trim(),
          }))
        );
      });
  }, []);

  const handleChange = (e) => {
    const arr = [...originalList];
    let result =
      arr &&
      arr.filter((item) => e && e.filter((i) => i.id === item.id).length === 0);
    if (e === null) {
      result = [...originalList];
      setSaleOffList([]);
    }
    setSaleOffList(e);
    setSaleOffNameSapCode(result);
  };

  // titleChange = (e) => {
  //   console.log('e >>>>>>>>>', e.target.value);
  //   if(e.target.value === '' || e.target.value === undefined || e.target.value === null || !e.target.value.trim().length){
  //       this.setState({
  //       validationError: true,
  //       validationTitleError: true
  //     });
  //   }else {
  //     this.setState({
  //       validationError: false,
  //       validationTitleError: false
  //     });
  //   }
  //   this.setState({ inAppTitle: e.target.value });
  // };

  const purposeChange = (e) => {
    console.log("e >>>>>>>>>", e.target.value);
    if (
      e.target.value === "" ||
      e.target.value === undefined ||
      e.target.value === null ||
      !e.target.value.trim().length
    ) {
      setValidationError(true);
      setValidationPurposeError(true);
    } else {
      setValidationError(false);
      setValidationPurposeError(false);
    }
    setSmsPurpose(e.target.value);
  };

  // sales officer list
  const salesOfficerListCall = () => {
    const options = CommonHeaderOption();
    const apiUrl = RUN_TIME_API_ENDPOINT;
    options.method = "GET";
    fetch(`${apiUrl}/get_sales_officers_by_country`, options)
      .then((res) => {
        return res.json();
      })
      .then((jsonD) => {
        console.log("jsonD ===>", jsonD);
        let obj = {};
        obj.sap_order_materials = jsonD.data;
        if (jsonD.data) {
          console.log("obj==>", obj);
          setOriginalSOList(
            obj.sap_order_materials.map((item) => ({
              id: item.id,
              value: item.email,
              label: item.username
                ? item.username + " - " + item.email
                : item.email,
            }))
          );
          setSoSapCodeList(
            obj.sap_order_materials.map((item) => ({
              id: item.id,
              value: item.email,
              label: item.username
                ? item.username + " - " + item.email
                : item.email,
            }))
          );
        }
      });
  };

  const salesOfficerRetailListCall = (soList) => {
    console.log("list of so", soList);
    const soIds = soList.map((e) => e.id);
    // const urlParams = new URLSearchParams(Object.entries(al));
    const urlParams = encodeURIComponent(JSON.stringify(soIds));
    const options = CommonHeaderOption();
    const apiUrl = RUN_TIME_API_ENDPOINT;
    options.method = "GET";
    fetch(
      `${apiUrl}/businesses_list_for_salesofficers?ids=${urlParams}`,
      options
    )
      .then((res) => {
        return res.json();
      })
      .then((jsonD) => {
        console.log("jsonD ===>", jsonD);
        let obj = {};
        obj.sap_order_materials = jsonD.data;
        // console.log('obj==>', obj);
        setOriginalList(
          obj.sap_order_materials.map((item) => ({
            id: item.id,
            value: item.label,
            label: item.label,
            sap: item.sap_code.trim(),
          }))
        );
        setSaleOffNameSapCode(
          obj.sap_order_materials.map((item) => ({
            id: item.id,
            value: item.label,
            label: item.label,
            sap: item.sap_code.trim(),
          }))
        );
        setSaleOffList(
          obj.sap_order_materials.map((item) => ({
            id: item.id,
            value: item.label,
            label: item.label,
            sap: item.sap_code.trim(),
          }))
        );
      });
  };

  const soRetailHandleChange = (e) => {
    const arr = [...originalList];
    let result =
      arr &&
      arr.filter((item) => e && e.filter((i) => i.id === item.id).length === 0);
    if (e === null) {
      result = [...originalList];
      setSaleOffList([]);
    }
    setSaleOffList(e);
    setSaleOffNameSapCode(result);
  };

  const soHandleChange = (e) => {
    console.log("hiiii", e);
    console.log("saleOffNameSapCode in handleChange", soSapCodeList);
    const arr = [...originalSOList];

    let result =
      arr &&
      arr.filter((item) => e && e.filter((i) => i.id === item.id).length === 0);
    if (e === null) {
      result = [...originalSOList];
      setSoList([]);
      setIsSoListPresent(false);
      setSaleOffList([]);
    } else {
      setIsSoListPresent(true);
    }
    setSoList(e);
    setSoSapCodeList(result);
    if (e !== null) {
      salesOfficerRetailListCall(e);
    }
  };
  // sales officer list

  // region list
  const regionListCall = () => {
    const options = CommonHeaderOption();
    const apiUrl = RUN_TIME_API_ENDPOINT;
    options.method = "GET";
    fetch(`${apiUrl}/list_of_regions`, options)
      .then((res) => {
        return res.json();
      })
      .then((jsonD) => {
        console.log("jsonD ===>", jsonD);
        let obj = {};
        obj.sap_order_materials = jsonD.data;
        if (jsonD.data) {
          console.log("obj==>", obj);
          setOriginalRegionList(
            obj.sap_order_materials.map((item) => ({
              id: item.id,
              value: item.name,
              label: item.name,
            }))
          );
          setRegionSapCodeList(
            obj.sap_order_materials.map((item) => ({
              id: item.id,
              value: item.name,
              label: item.name,
            }))
          );
        }
      });
  };

  const regionRetailListCall = (regionList) => {
    console.log("list of djkffjgfjgfgjfkgj", regionList);
    const regIds = regionList.map((e) => e.id);
    // const urlParams = new URLSearchParams(Object.entries(al));
    const urlParams = encodeURIComponent(JSON.stringify(regIds));
    const options = CommonHeaderOption();
    const apiUrl = RUN_TIME_API_ENDPOINT;
    options.method = "GET";
    fetch(`${apiUrl}/get_business_by_region?region_ids=${urlParams}`, options)
      .then((res) => {
        return res.json();
      })
      .then((jsonD) => {
        console.log("jsonD ===>", jsonD);
        let obj = {};
        obj.sap_order_materials = jsonD.data;
        // console.log('obj==>', obj);
        setOriginalList(
          obj.sap_order_materials.map((item) => ({
            id: item.id,
            value: item.label,
            label: item.label,
            sap: item.sap_code.trim(),
          }))
        );
        setSaleOffNameSapCode(
          obj.sap_order_materials.map((item) => ({
            id: item.id,
            value: item.label,
            label: item.label,
            sap: item.sap_code.trim(),
          }))
        );
        setSaleOffList(
          obj.sap_order_materials.map((item) => ({
            id: item.id,
            value: item.label,
            label: item.label,
            sap: item.sap_code.trim(),
          }))
        );
      });
  };

  const regionRetailHandleChange = (e) => {
    console.log("hiiii", e);
    console.log("saleOffNameSapCode in handleChange", saleOffNameSapCode);
    const arr = [...originalList];
    let result =
      arr &&
      arr.filter((item) => e && e.filter((i) => i.id === item.id).length === 0);
    if (e === null) {
      result = [...originalList];
      setSaleOffList([]);
    }
    setSaleOffList(e);
    setSaleOffNameSapCode(result);
  };

  const regionHandleChange = (e) => {
    console.log("hiiii", e);
    console.log("saleOffNamdkfdjkjjfdjfkdjfe", regionSapCodeList);
    const arr = [...originalRegionList];
    let result =
      arr &&
      arr.filter((item) => e && e.filter((i) => i.id === item.id).length === 0);
    if (e === null) {
      result = [...originalRegionList];
      setRegionList([]);
      setIsRegionListPresent(false);
      setSaleOffList([]);
    } else {
      setIsRegionListPresent(true);
    }
    setRegionList(e);
    setRegionSapCodeList(result);
    if (e !== null) {
      regionRetailListCall(e);
    }
  };
  // region list

  // customer group list
  const customerGroupListCall = () => {
    const options = CommonHeaderOption();
    const apiUrl = RUN_TIME_API_ENDPOINT;
    options.method = "GET";
    fetch(`${apiUrl}/customer_group_country`, options)
      .then((res) => {
        return res.json();
      })
      .then((jsonD) => {
        console.log("jsonD ===>", jsonD);
        let obj = {};
        obj.sap_order_materials = jsonD.data;
        if (jsonD.data) {
          console.log("obj==>", obj);
          setOriginalCustomerGroupList(
            obj.sap_order_materials.map((item) => ({
              id: item.id,
              value: item.code,
              label: item.description,
            }))
          );
          setCustomerGroupSapCodeList(
            obj.sap_order_materials.map((item) => ({
              id: item.id,
              value: item.code,
              label: item.description,
            }))
          );
        }
      });
  };

  const customerGroupRetailCall = (customerGroupList) => {
    console.log("list of djkffjgfjgfgjfkgj", customerGroupList);
    const regIds = customerGroupList.map((e) => e.value);
    // const urlParams = new URLSearchParams(Object.entries(al));
    const urlParams = encodeURIComponent(JSON.stringify(regIds));
    const options = CommonHeaderOption();
    const apiUrl = RUN_TIME_API_ENDPOINT;
    options.method = "GET";
    fetch(`${apiUrl}/retailer_customer_group?code=${urlParams}`, options)
      .then((res) => {
        return res.json();
      })
      .then((jsonD) => {
        console.log("jsonD ===>", jsonD);
        let obj = {};
        obj.sap_order_materials = jsonD.data;
        // console.log('obj==>', obj);
        setOriginalList(
          obj.sap_order_materials.map((item) => ({
            id: item.id,
            value: item.label,
            label: item.label,
            sap: item.sap_code.trim(),
          }))
        );
        setSaleOffNameSapCode(
          obj.sap_order_materials.map((item) => ({
            id: item.id,
            value: item.label,
            label: item.label,
            sap: item.sap_code.trim(),
          }))
        );
        setSaleOffList(
          obj.sap_order_materials.map((item) => ({
            id: item.id,
            value: item.label,
            label: item.label,
            sap: item.sap_code.trim(),
          }))
        );

        // this.setState({
        //   originalList: obj.sap_order_materials.map(item => ({ 'id': item.id, 'value': item.label, 'label': item.label, 'sap': item.sap_code.trim() })),
        //   saleOffNameSapCode: obj.sap_order_materials.map(item => ({ 'id': item.id, 'value': item.label, 'label': item.label, 'sap': item.sap_code.trim() })),
        //   saleOffList: obj.sap_order_materials.map(item => ({ 'id': item.id, 'value': item.label, 'label': item.label, 'sap': item.sap_code.trim() })),
        // });
      });
  };

  const customerRetailerHandleChange = (e) => {
    console.log("hiiii", e);
    console.log("saleOffNameSapCode in handleChange", saleOffNameSapCode);
    const arr = [...originalList];

    let result =
      arr &&
      arr.filter((item) => e && e.filter((i) => i.id === item.id).length === 0);
    if (e === null) {
      result = [...originalList];
      setSaleOffList([]);
    }
    setSaleOffList(e);
    setSaleOffNameSapCode(result);
  };

  const customerGroupHandleChange = (e) => {
    console.log("hiiii", e);
    console.log("saleOffNamdkfdjkjjfdjfkdjfe", regionSapCodeList);
    const arr = [...originalCustomerGroupList];

    let result =
      arr &&
      arr.filter((item) => e && e.filter((i) => i.id === item.id).length === 0);
    if (e === null) {
      result = [...originalRegionList];
      setCustomerGroupList([]);
      setIscustomerGroupListPresent(false);
      setSaleOffList([]);
    } else {
      setIscustomerGroupListPresent(true);
    }
    setCustomerGroupList(e);
    setCustomerGroupSapCodeList(result);
    if (e !== null) {
      customerGroupRetailCall(e);
    }
  };
  // customer group list

  const selectHandleChange = (event) => {
    setType(event.target.value);
    // this.setState({ type: event.target.value });
    if (event.target.value === "Sales") {
      console.log("salessss");
      setSaleOffList([]);
      setSoSapCodeList([]);
      setSoList([]);
      // this.setState({ saleOffList: [], soSapCodeList: [], soList: [] });
      salesOfficerListCall();
    }

    if (event.target.value === "Region") {
      setSaleOffList([]);
      setRegionSapCodeList([]);
      setRegionList([]);
      // this.setState({ saleOffList: [], regionSapCodeList: [], regionList: [] });
      regionListCall();
    }

    if (event.target.value === "customerGroup") {
      setSaleOffList([]);
      setCustomerGroupSapCodeList([]);
      setCustomerGroupList([]);
      // this.setState({ saleOffList: [], customerGroupSapCodeList: [], customerGroupList: [] });
      customerGroupListCall();
    }
  };

  const descriptionChange = (e) => {
    console.log("e >>>>>>>>>", e.target.value);
    const charCount = e.target.value.length;
    const maxChar = descMaxChar;
    const charLength = maxChar - charCount;
    const messages = Math.ceil(charCount / 160);

    if (
      e.target.value === "" ||
      e.target.value === undefined ||
      e.target.value === null ||
      !e.target.value.trim().length
    ) {
      setValidationError(true);
      setValidateDescriptionError(true);
      setMessageCount(0);
      setDescCharLeft(charLength);
      // this.setState({
      //   validationError: true,
      //   validateDescriptionError: true,
      //   messageCount: 0,
      //   descCharLeft: charLength,
      // });
    } else {
      setValidationError(false);
      setValidateDescriptionError(false);
      setDescCharLeft(charLength);
      setMessageCount(messages);
      // this.setState({
      //   validationError: false,
      //   validateDescriptionError: false,
      //   descCharLeft: charLength,
      //   messageCount: messages
      // });
    }
    setSmsDescription(e.target.value);
    // this.setState({ smsDescription: e.target.value });
  };

  const onModalClose = () => {
    setShowModal(false);
    // this.setState({
    //   showModal: false,
    // });
  };

  const formSave = () => {
    setShowLoader(true);
    setSaveButtonDisabled(false);
    // this.setState({
    //   showLoader: true,
    //   saveButtonDisabled: false
    // });
    const checkType =
      type === "Sales" || type === "Region" || type === "customerGroup"
        ? "Business"
        : type;
    const formData = {
      // title: inAppTitle,
      text: smsDescription.trim(),
      type: checkType,
      name_sap_code: saleOffList,
      purpose: smsPurpose.trim(),
    };
    console.log("formData>>>>>>", formData);

    const apiUrl = RUN_TIME_API_ENDPOINT;
    const options = CommonHeaderOption();
    options.method = "POST";
    options.body = JSON.stringify({ formData });

    console.log("options =============", options);

    return fetch(`${apiUrl}/sms_blasts`, options)
      .then((res) => {
        console.log("res12...........", res);
        if (res) {
          return res.json();
        }
      })
      .then((res) => {
        if (res.errorMsg) {
          setErrorMsg(true);
          setShowLoader(false);
          setErrorMsgText(res.errorMsg);
          // this.setState({
          //   errorMsg: true,
          //   showLoader: false,
          //   errorMsgText: res.errorMsg
          // });
          setTimeout(() => {
            setErrorMsg(false);
            setSaveButtonDisabled(true);
            // this.setState({
            //   errorMsg: false,
            //   saveButtonDisabled: true
            // });
          }, 3000);
        } else {
          console.log("res...........", res);
          setShowLoader(false);
          setSaveButtonDisabled(true);
          setSuccessMsg(true);
          // this.setState({
          //   showLoader: false,
          //   saveButtonDisabled: true,
          //   successMsg: true
          // });
          setTimeout(() => {
            setSuccessMsg(false);
            // this.setState({ successMsg: false });
          }, 2000);
          setTimeout(() => {
            navigate("/sms_blasts");
          }, 3000);
          console.log("res", res);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleFile = (e) => {
    let file = null;
    file = e.target.files[0];
    const fileType = file.name.substring(
      file.name.lastIndexOf(".") + 1,
      file.name.length
    );
    if (
      file === null ||
      typeof file === "undefined" ||
      file === "" ||
      typeof file === undefined ||
      fileType.toLowerCase() !== "csv"
    ) {
      Swal.fire({
        text: "Please choose a valid .csv file.",
        confirmButtonText: `OK`,
        icon: "error",
      });
      file = null;
      console.log("bad file");
    } else {
      console.log([e.target.name], e.target.files[0]);
      setUnregisteredRetailers([]);
      setPasrsedSimilarDataLength(0);
      setPasrsedDifferentDataLength(0);
      // this.setState({
      //   unregisteredRetailers: [],
      //   pasrsedSimilarDataLength: 0,
      //   pasrsedDifferentDataLength: 0,
      // });
      Papa.parse(file, {
        header: true,
        skipEmptyLines: true,
        complete: (results) => {
          const checkValidHeader = Object.keys(results.data[0]);
          // console.log('results======>', Object.keys(results.data[0]).includes('COMPANYNAME'));
          if (
            checkValidHeader.includes("COMPANYNAME") &&
            checkValidHeader.includes("SAPID")
          ) {
            const parseddata =
              permissions.permissions === "isSap"
                ? results.data.map((item, i) => ({
                    id: i,
                    value: item.COMPANYNAME + "-0000" + item.SAPID,
                    label: item.COMPANYNAME + "-0000" + item.SAPID,
                    sap: "0000" + item.SAPID.trim(),
                  }))
                : results.data.map((item, i) => ({
                    id: i,
                    value: item.COMPANYNAME + " " + item.SAPID,
                    label: item.COMPANYNAME + " " + item.SAPID,
                    sap: item.SAPID.trim(),
                  }));
            console.log(parseddata);
            let pasrsedSimilarData = [];
            pasrsedSimilarData = originalList.filter((a1) =>
              parseddata.some((a2) => a1.sap === a2.sap)
            );
            if (pasrsedSimilarData && pasrsedSimilarData.length) {
              const similarArray =
                saleOffList !== null
                  ? saleOffList.filter(
                      ({ sap: id1 }) =>
                        !pasrsedSimilarData.some(({ sap: id2 }) => id2 === id1)
                    )
                  : [];
              setSaleOffList([...similarArray, ...pasrsedSimilarData]);
              setPasrsedSimilarDataLength(pasrsedSimilarData.length);
              // this.setState({ saleOffList: [...similarArray, ...pasrsedSimilarData], pasrsedSimilarDataLength: pasrsedSimilarData.length })
            }
            const pasrsedDifferentData = parseddata.filter((a1) =>
              pasrsedSimilarData.every((a2) => a1.sap !== a2.sap)
            );
            if (pasrsedDifferentData && pasrsedDifferentData.length) {
              console.log(pasrsedDifferentData, pasrsedDifferentData.length);
              setUnregisteredRetailers([...pasrsedDifferentData]);
              setPasrsedDifferentDataLength(pasrsedDifferentData.length);
              // this.setState({ unregisteredRetailers: [...pasrsedDifferentData], pasrsedDifferentDataLength: pasrsedDifferentData.length })
            }
            console.log("seprated", pasrsedSimilarData, pasrsedDifferentData);
            setParsedCSVdata([...parseddata]);
            // this.setState({ parsedCSVdata: [...parseddata] });
          } else {
            file = null;
            Swal.fire({
              text: "File headers do not match. Kindly download and refer the sample file.",
              confirmButtonText: `OK`,
              icon: "error",
            });
          }
        },
      });
    }
  };

  const cancelClick = () => {
    setSaleOffList([]);
    setSaleOffNameSapCode(originalList);
    setUnregisteredRetailers([]);
    setPasrsedSimilarDataLength(0);
    setPasrsedDifferentDataLength(0);
  };

  const cancelSalesClick = () => {
    setSaleOffList([]);
    setSaleOffNameSapCode(originalList);
    setSoSapCodeList(originalSOList);
    setSoList([]);
    setIsSoListPresent(false);
  };

  const cancelRegionClick = () => {
    setSaleOffList([]);
    setSaleOffNameSapCode(originalList);
    setRegionList([]);
    setRegionSapCodeList(originalRegionList);
    setIsRegionListPresent(false);
  };

  const cancelCustomerGroupClick = () => {
    setSaleOffList([]);
    setSaleOffNameSapCode(originalList);
    setCustomerGroupList([]);
    setCustomerGroupSapCodeList(originalCustomerGroupList);
    setIscustomerGroupListPresent(false);
  };

  const toggleUnregisteredRetailers = () => {
    setUnregisteredRetailersToggle(!unregisteredRetailersToggle);
  };

  return (
    <div>
      <div className="notification-list-button">
        <ListButton basePath={props.basePath} />
      </div>
      <div className="so-form-container">
        <div className="so-form">
          <div className="so-input">
            <label>
              Message Purpose<sup className="asterisk">*</sup>
            </label>
            <input
              className="form-control"
              type="text"
              name="Purpose"
              value={smsPurpose || ""}
              onChange={purposeChange}
            />
            {validationPurposeError && (
              <p className="so-input-error">Please enter a Purpose</p>
            )}
          </div>

          {/* <div className="so-input">
            <label>Notification Title<sup className="asterisk">*</sup></label>
            <input
              className="form-control"
              type="text"
              name="Title"
              value={this.state.inAppTitle || ''}
              onChange={this.titleChange}
            />
            {this.state.validationTitleError &&
              <p>Please enter a title</p>
            }
          </div> */}

          <div className="so-input">
            <label>
              Message Description<sup className="asterisk">*</sup>
            </label>
            <textarea
              className="inapp-notification-description"
              name="description"
              maxLength="640"
              value={smsDescription}
              onChange={descriptionChange}
            />
            {validateDescriptionError && (
              <p className="so-input-error">Please enter a description</p>
            )}
            <p className="characters-remaining">
              {descCharLeft} characters remaining
            </p>
            <p className="sms-count">Sms count: {messageCount}</p>
          </div>

          {/* <input type="file" id="file" onChange={this.handleFile} /> */}

          <div className="so-input">
            <label>
              Message Send To<sup className="asterisk">*</sup>
            </label>
            <select
              className="inapp-notification-sendto"
              name="type"
              value={type}
              onChange={selectHandleChange}
            >
              <option value="Country">All Retailers</option>
              <option value="Business">A set of Retailers</option>
              {getLocalStorageKey("is_sales_off_app_present") ? (
                <option value="Sales">Sales Officers of Retailers</option>
              ) : (
                ""
              )}
              {permissions.permissions === "isSap" && (
                <option value="Region">Regions of Retailers</option>
              )}
              {permissions.permissions === "isSap" ||
              permissions.permissions === "isSageAPI" ? (
                <option value="customerGroup">
                  Customer Group of Retailers
                </option>
              ) : null}
            </select>
          </div>

          {type === "Sales" && (
            <React.Fragment>
              <label className="select-label">
                Choose Sales Officer<sup className="asterisk">*</sup> (Atleast
                select one sales officer)
              </label>
              <div className="select-retailer">
                <Select
                  value={soList}
                  onChange={soHandleChange}
                  options={soSapCodeList}
                  isMulti
                />
                <button onClick={cancelSalesClick}>Clear</button>
              </div>
            </React.Fragment>
          )}

          {type === "Sales" && isSoListPresent && (
            <React.Fragment>
              <label className="select-label">
                Choose Retailer<sup className="asterisk">*</sup> (Atleast select
                one retailer)
              </label>
              <div className="select-retailer">
                <Select
                  onChange={soRetailHandleChange}
                  value={saleOffList}
                  options={saleOffNameSapCode}
                  isMulti
                />
                <button onClick={cancelSalesClick}>Clear</button>
              </div>
            </React.Fragment>
          )}

          {type === "Region" && (
            <React.Fragment>
              <label className="select-label">
                Choose Region<sup className="asterisk">*</sup> (Atleast select
                one Region)
              </label>
              <div className="select-retailer">
                <Select
                  value={regionList}
                  onChange={regionHandleChange}
                  options={regionSapCodeList}
                  isMulti
                />
                <button onClick={cancelRegionClick}>Clear</button>
              </div>
            </React.Fragment>
          )}

          {type === "Region" && isRegionListPresent && (
            <React.Fragment>
              <label className="select-label">
                Choose Retailer<sup className="asterisk">*</sup> (Atleast select
                one retailer)
              </label>
              <div className="select-retailer">
                <Select
                  onChange={regionRetailHandleChange}
                  value={saleOffList}
                  options={saleOffNameSapCode}
                  isMulti
                />
                <button onClick={cancelRegionClick}>Clear</button>
              </div>
            </React.Fragment>
          )}

          {type === "customerGroup" && (
            <React.Fragment>
              <label className="select-label">
                Choose Customer Group<sup className="asterisk">*</sup> (Atleast
                select one Group)
              </label>
              <div className="select-retailer">
                <Select
                  value={customerGroupList}
                  onChange={customerGroupHandleChange}
                  options={customerGroupSapCodeList}
                  isMulti
                />
                <button onClick={cancelCustomerGroupClick}>Clear</button>
              </div>
            </React.Fragment>
          )}

          {type === "customerGroup" && isCustomerGroupListPresent && (
            <React.Fragment>
              <label className="select-label">
                Choose Customer Retailer<sup className="asterisk">*</sup>{" "}
                (Atleast select one Retailer)
              </label>
              <div className="select-retailer">
                <Select
                  onChange={customerRetailerHandleChange}
                  value={saleOffList}
                  options={saleOffNameSapCode}
                  isMulti
                />
                <button onClick={cancelCustomerGroupClick}>Clear</button>
              </div>
            </React.Fragment>
          )}

          {type === "Business" && (
            <div>
              <div className="csv-file-upload-container target-upload-container">
                <label>Upload File</label>
                {/* <input type="file" accept=".csv" name="flies[]" /> */}
                <input
                  type="file"
                  id="file"
                  accept=".csv"
                  onChange={handleFile}
                />
                <div className="valid-file-upload">
                  <p>Instructions :</p>
                  <ul>
                    <li>Only CSV files are allowed with Comma as separator.</li>
                  </ul>
                </div>
                <div className="upload-file-format-download">
                  <p>
                    To get upload file format.{" "}
                    <a
                      href="https://navendor-global-production.s3-eu-west-1.amazonaws.com/infographics/sample.csv"
                      target="_blank"
                    >
                      Click here
                    </a>{" "}
                    to download
                  </p>
                </div>
              </div>

              {pasrsedSimilarDataLength > 0 ||
              pasrsedDifferentDataLength > 0 ? (
                <div className="csv-result-container">
                  <label>CSV Result</label>
                  <div className="csv-result">
                    <div>
                      <p onClick={toggleUnregisteredRetailers}>
                        {pasrsedSimilarDataLength} retailers found,{" "}
                        {pasrsedDifferentDataLength} retailers unregistered.
                        {pasrsedDifferentDataLength > 0
                          ? " Click to view unregistererd retailers"
                          : ""}
                        {pasrsedDifferentDataLength > 0 ? (
                          <span
                            className={
                              unregisteredRetailersToggle
                                ? `icon-arrow_down`
                                : `icon-arrow_up`
                            }
                          />
                        ) : (
                          ""
                        )}
                      </p>
                      {pasrsedDifferentDataLength > 0 ? (
                        <div
                          className={
                            unregisteredRetailersToggle
                              ? `hide-unregistered`
                              : `show-unregistered`
                          }
                        >
                          <React.Fragment>
                            {unregisteredRetailers?.length > 0 &&
                              unregisteredRetailers.map((item) => (
                                <p key={item.id}>{item.label}</p>
                              ))}
                          </React.Fragment>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}

              <label className="select-label">
                Choose Retailers<sup className="asterisk">*</sup> (Atleast
                select one retailer)
              </label>
              <div className="select-retailer">
                <Select
                  value={saleOffList}
                  onChange={handleChange}
                  options={saleOffNameSapCode}
                  isMulti
                />
                <button onClick={cancelClick}>Clear</button>
              </div>
            </div>
          )}

          {
            type === "Business" && messageCount > 0 && saleOffList !== null && (
              <div>total cost : {saleOffList.length * messageCount} </div>
            )
            // :
            // <div className="sms-total-cost"> Total cost: {this.state.saleOffNameSapCode.length * this.state.messageCount}</div>
          }
        </div>
        {saveButtonDisabled && (
          <div className="so-save-button">
            <button
              className={
                !smsDescription ||
                !smsPurpose ||
                validateDescriptionError ||
                validationPurposeError ||
                (type === "Business" && !saleOffList)
                  ? "disable-save"
                  : ""
              }
              disabled={
                validateDescriptionError ||
                validationPurposeError ||
                !smsDescription ||
                !smsPurpose ||
                (type === "Business" && !saleOffList)
              }
              onClick={() => formSave()}
            >
              Save
            </button>
          </div>
        )}

        {showLoader && <div className="save-loader" />}
        {successMsg && <div className="so-updated">Successfully Created </div>}
        {errorMsg && <div className="so-email-exist">{errorMsgText}</div>}
      </div>
    </div>
  );
};

export default SendMessageCreate;
